import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Message icon — chat bubble with content lines and a reply tail.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const MessageIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M14.1973 1.07153H2.94727C1.9118 1.07153 1.07227 1.91106 1.07227 2.94653V10.4465C1.07227 11.482 1.9118 12.3215 2.94727 12.3215H5.75977L9.50977 16.0715V12.3215H14.1973C15.2327 12.3215 16.0723 11.482 16.0723 10.4465V2.94653C16.0723 1.91106 15.2327 1.07153 14.1973 1.07153ZM15.2687 10.4465C15.2687 10.9638 14.7141 11.518 14.1973 11.518H8.57227L8.84012 14.4644L6.16155 11.518H2.94727C2.43047 11.518 1.87584 10.9638 1.87584 10.4465V2.94653C1.87584 2.42927 2.43047 1.8751 2.94727 1.8751H14.1973C14.7141 1.8751 15.2687 2.42927 15.2687 2.94653V6.69653V10.4465Z"
      fill="currentColor"
    />
    <path
      d="M3.75 4.5535C3.75 4.70144 3.86992 4.82136 4.01786 4.82136H13.125C13.2729 4.82136 13.3929 4.70144 13.3929 4.5535C13.3929 4.40557 13.2729 4.28564 13.125 4.28564H4.01786C3.86992 4.28564 3.75 4.40557 3.75 4.5535Z"
      fill="currentColor"
    />
    <path
      d="M3.75 6.69632C3.75 6.84426 3.86992 6.96418 4.01786 6.96418H13.125C13.2729 6.96418 13.3929 6.84426 13.3929 6.69632C13.3929 6.54839 13.2729 6.42847 13.125 6.42847H4.01786C3.86992 6.42847 3.75 6.54839 3.75 6.69632Z"
      fill="currentColor"
    />
    <path
      d="M3.75 8.83939C3.75 8.98732 3.86992 9.10725 4.01786 9.10725H9.375C9.52293 9.10725 9.64286 8.98732 9.64286 8.83939C9.64286 8.69146 9.52293 8.57153 9.375 8.57153H4.01786C3.86992 8.57153 3.75 8.69146 3.75 8.83939Z"
      fill="currentColor"
    />
  </svg>
);

export default MessageIcon;
